export default {
  fieldsWhiteMark: {
    default: 'Marque blanche',
    switch: 'Marque blanche',
    infos: 'Champs personnalisés',
    info: {
      phoneNumber: 'Téléphone de la société',
      emergencyContact: 'Numéro d\'urgence',
      mail: 'Email de la société',
      openingHours: 'Horaires d\'ouverture'
    },
    alert: {
      add: {
        success: 'Action effectuée avec succès',
        danger: 'Une erreur est survenue'
      },
      delete: {
        success: 'Marque blanche supprimée avec succès',
        danger: 'Une erreur est survenue'
      }
    }
  }
}
